/**
 * 网站配置文件
 * 在此文件中修改网站相关信息，所有使用该配置的地方都会自动更新
 */

export default {
    // 网站基本信息
    siteName: '起号云', // 网站名称
    siteTitle: '起号云-短视频在线去重混剪', // 网站标题（用于浏览器标题栏）
    siteDescription: '起号云，在线制作视频去重、混剪，一键制作属于自己的短视频，让视频多样化。', // 网站描述（用于SEO）
    siteKeywords: '起号云，视频去重，视频混剪，在线去重，在线混剪，一键制作属于自己的短视频，让视频多样化。', // 网站关键词（用于SEO）

    // 公司信息
    companyName: '太原思由网络科技有限公司', // 公司名称
    icpNumber: '晋ICP备2022004008号', // ICP备案号
    icpLink: 'https://beian.miit.gov.cn/#/Integrated/index', // ICP备案链接

    // 网站资源路径
    logoPath: require('@/assets/img/qhy2.png'), // Logo路径
    faviconPath: require('@/assets/img/qhy2.png'), // 网站图标路径

    // 其他配置
    copyright: '2022 All Rights Reserved', // 版权信息
    version: '1.0.0' // 网站版本号
}




// WEBPACK FOOTER //
// ./src/config/site.js